import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { ClockIcon } from 'lucide-react';

export const TimeDisplay: React.FC = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Format local time in 24-hour format (without timezone)
  const localTime = format(currentTime, 'HH:mm:ss');
  
  // Format UTC time in 24-hour format
  const pad = (n: number) => n.toString().padStart(2, '0');
  const utcTime = `${pad(currentTime.getUTCHours())}:${pad(currentTime.getUTCMinutes())}:${pad(currentTime.getUTCSeconds())}`;

  return (
    <div className="flex items-center space-x-2 text-sm">
      <ClockIcon size={16} className="text-gray-500 flex-shrink-0" />
      <div className="flex flex-col leading-tight">
        <div className="text-gray-700 font-medium whitespace-nowrap">
          {localTime}
        </div>
        <div className="text-gray-500 text-xs whitespace-nowrap">
          {utcTime} UTC
        </div>
      </div>
    </div>
  );
}; 